import {
  PageTypePrefixes,
  defaultLanguage,
  Languages
} from '@stereoagency/constants';

const i18n = {
  loader: false,
  defaultLocale: defaultLanguage.id,
  locales: Languages.map((lang) => lang.id),
  pages: {
    '*': [
      'global',
      'departments',
      'home',
      'contact-form',
      'footer',
      'donation-box',
      'legacy-simulator'
    ],

    [PageTypePrefixes.en.article]: ['news'],
    [PageTypePrefixes.fr.article]: ['news'],
    [PageTypePrefixes.nl.article]: ['news'],

    [PageTypePrefixes.en.researchGroup]: ['research-group-or-platform'],
    [PageTypePrefixes.fr.researchGroup]: ['research-group-or-platform'],
    [PageTypePrefixes.nl.researchGroup]: ['research-group-or-platform'],
    [PageTypePrefixes.en.researchPlatform]: ['research-group-or-platform'],
    [PageTypePrefixes.fr.researchPlatform]: ['research-group-or-platform'],
    [PageTypePrefixes.nl.researchPlatform]: ['research-group-or-platform'],

    [PageTypePrefixes.en.event]: ['event'],
    [PageTypePrefixes.fr.event]: ['event'],
    [PageTypePrefixes.nl.event]: ['event'],

    [PageTypePrefixes.en.search]: ['search'],
    [PageTypePrefixes.fr.search]: ['search'],
    [PageTypePrefixes.nl.search]: ['search']
  },
  loadLocaleFrom: (lang: string | undefined, ns: string) => {
    // eslint-disable-next-line
    const mod = require(`@stereoagency/locales/translations/${
      lang ?? i18n.defaultLocale
    }/${ns}.json`);
    return Promise.resolve(mod);
  }
};

export default i18n;
